type PersistableQuery = {
  meta?: { persist?: boolean } & Record<string, unknown>;
  queryKey?: readonly unknown[];
  state: { status: string };
};

const isReviewElevationScope = (part: unknown) =>
  typeof part === 'object' && part !== null && 'reviewingAs' in part;

/**
 * Whether a query may be written to the persisted (IndexedDB) react-query cache.
 *
 * Queries opt out with `meta: { persist: false }` — used by anything whose stale value is worse
 * than no value, such as a platform kill switch that would otherwise rehydrate a day old. A query
 * read under a manager's review elevation (a `reviewingAs` key entry) is never persisted, since the
 * store belongs to the signed-in attendant.
 */
export const shouldPersistQuery = (query: PersistableQuery): boolean => {
  if (query.meta?.persist === false) return false;
  if (query.queryKey?.some(isReviewElevationScope)) return false;

  return query.state.status === 'success';
};
